module.exports = __webpack_public_path__ + "static/bride-champagne-0fca036026d60fd2ee9631834a7316df.svg";